export default __webpack_public_path__ + "static/media/RECoin.614a293f.svg";